export const stickNavbar = (setScroll, threshold) => {
  if (window !== undefined) setScroll(window.scrollY > threshold)
}
